<div class="blender-floor-viewer-container" [class.fullscreen-instance]="isFullscreenInstance">
  @if (!useSharedLeafletBackground) {
    <div #leafletMap class="blender-leaflet-map"></div>
  }
  <app-building-3d-viewer
    #building3dViewer
    [embedded]="false"
    [transparentBackground]="true"
    [showHeader]="false"
    [active]="true"
    [assetBundle]="assetBundle"
    [assetResolutionKey]="assetBundle ? null : assetResolutionKey"
    [assetResolutionKeys]="[]"
    [roomStatusColors]="roomStatusColors"
    [alertRecords]="alertRecords"
    [liveUserData]="liveUserData"
    [liveUserAssetConfig]="liveUserAssetConfig"
    [flipVertical]="flipVertical"
    [showBeacons]="showBeacons"
    [floorMapEntity]="floorMapEntity"
    (userClicked)="onUserClicked($event)"
    (metadataParsed)="onModelMetadataParsed($event)"
    (loadingChange)="onLoadingChange($event)">
  </app-building-3d-viewer>
</div>
